<template>
  <v-card class="pa-8 mb-2" color="grey-lighten-4" flat rounded="lg">
    <div class="d-flex flex-column align-center">
      <v-img class="app-logo mb-8" src="/img/deepsign_app.png" />
      <div class="hint-text mb-2">
        {{ i18n.t('texts.open_deep_id') }}
      </div>
      <div class="d-flex flex-row align-center justify-center">
        <div class="mr-2 app-store-available">
          {{ i18n.t('texts.available_on') }}
        </div>
        <v-icon class="mr-2" color="grey" size="18">fab fa-apple</v-icon>
        <v-icon color="grey" size="16">fab fa-google-play</v-icon>
      </div>
      <a class="action-link" @click="emit('show-qr')">
        {{ i18n.t('actions.open_on_different_device') }}
      </a>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const i18n = useI18n();
const emit = defineEmits(['show-qr']);
</script>

<style scoped lang="scss">
.app-logo {
  aspect-ratio: 1 !important;
  height: 102px;
  width: 102px;
  border-radius: 16px;
  border: 1px solid rgb(var(--v-theme-lighten-2));
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.hint-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: black;
}
.action-link {
  margin-top: 1rem;
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
.app-store-available {
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: rgb(var(--v-theme-lighten-1));
}
</style>
